<div class="list-page">
  <app-asiakas-otsikko otsikko="Asetukset, sopimukset" paluuUrl="/asiakkaat" [asiakas]="asiakas()"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Asiakas: <a [href]="asiakasEncodedUriObservable | async" target="_BLANK">{{ asiakasUriObservable | async }}</a>
      </div>
      <div style="margin: 20px">
        <form>
          <mat-checkbox [formField]="asiakkaanTietojenMuokkausLomake.naytaKayttajilleTervetuloaDialogi" [labelPosition]="'after'">Näytä kaikille käyttäjille Tervetuloa -dialogi</mat-checkbox><br />
          <mat-checkbox [formField]="asiakkaanTietojenMuokkausLomake.vaadiKayttajiltaUusiTunnistautuminen" [labelPosition]="'after'">Vaadi kaikilta käyttäjiltä vahva tunnistautuminen</mat-checkbox><br />
          <mat-checkbox [formField]="asiakkaanTietojenMuokkausLomake.vaadiPepTietojenPaivittaminen" [labelPosition]="'after'">Vaadi tuntemistietojen (PEP jne.) päivittäminen</mat-checkbox><br />
          <mat-checkbox [formField]="asiakkaanTietojenMuokkausLomake.vaadiSopimuksenAllekirjoittaminenUudelleen" [labelPosition]="'after'">Vaadi sopimuksen allekirjoittaminen uudelleen</mat-checkbox><br />
          <app-secondary-button (click)="muokkaaAsiakkaanAsetuksia()" actionId="Sopimukset: Muokkaa asiakkaan asetuksia" [actionContext]="[asiakkaanTietojenMuokkausLomake().value()]" styles="margin-top: 20px;"> Tallenna </app-secondary-button>
        </form>
      </div>
    </div>
  }

  @if (asiakas().sopimuskaudet?.length) {
    @for (sopimuskausi of sopimuskaudetCache(); track sopimuskausi; let i = $index) {
      <div style="margin-left: 20px; max-width: 1200px">
        <div style="display: flex; justify-content: space-between; margin-bottom: 32px; margin-top: 10px">
          <mat-card appearance="outlined" style="border-radius: 25px; width: 50%">
            <mat-card-title>
              <div class="light-blue-text" [class.mat-form-field-invalid]="sopimuskausiError()" style="display: flex; justify-content: space-between; font-size: 22px; margin-bottom: 10px; line-height: 30px">
                <div>Sopimuskausi {{ sopimuskausi.kausi.alkaa | lokaalipvm | async }}</div>
                <div style="font-size: 13px; font-weight: 400; color: black">
                  <!-- <span [style.background-color]=" sopimuskausi.tilanVarikoodi" style="width: 15px; height: 15px; border-radius: 50%; display: inline-block; vertical-align: middle; margin-top: -2px; margin-right: 3px;"></span> -->
                  <span asiakkaan-sopimuskauden-tila [tila]="sopimuskausi.tila"></span>
                  {{ sopimuskausi.tilanNimi }}
                </div>
              </div>
            </mat-card-title>
            <mat-card-content>
              <table>
                <tr>
                  <th style="text-align: left">Jakson aloituspvm:</th>
                  <td>{{ sopimuskausi.kausi.alkaa | lokaalipvm | async }}</td>
                  <td></td>
                </tr>
                <!--
                <ng-container *ngIf="sopimuskausi.hyvaksynnat.length > 0 else eiHyvaksyntaa">
                  <tr *ngFor="let hyvaksynta of sopimuskausi.hyvaksynnat">
                    <th style="text-align: left;">Allekirjoitus:</th>
                    <td>{{hyvaksynta.hyvaksynta.pvm | ltimestamp | async}}</td>
                    <td>{{hyvaksynta.hyvaksyja}}</td>
                  </tr>
                </ng-container>
                <ng-template #eiHyvaksyntaa>
                  <tr>
                    <th style="text-align: left;">Allekirjoitus:</th>
                    <td>Ei vielä allekirjoitettu</td>
                    <td></td>
                  </tr>
                </ng-template> -->
                @if (sopimuskausi.devaaja) {
                  <tr>
                    <th style="text-align: left">Luotu:</th>
                    <td>{{ sopimuskausi.kausi.luotu | ltimestamptime | async }}</td>
                    <td>{{ sopimuskausi.luoja }}</td>
                  </tr>
                  <tr>
                    <th style="text-align: left">Päivitetty:</th>
                    <td>{{ sopimuskausi.kausi.paivitetty | ltimestamptime | async }}</td>
                    <td>{{ sopimuskausi.paivittaja }}</td>
                  </tr>
                }
                <tr>
                  <th style="text-align: left">Laskutuksen aloitus:</th>
                  <td>{{ sopimuskausi.laskutusAlkaa }}</td>
                  <td></td>
                </tr>
              </table>
              @if (sopimuskausi.naytaPakotaSopimuksenAllekirjoitus) {
                <app-secondary-button (click)="pakotaSopimuksenAllekirjoittaminenUudelleen()" actionId="Avasi dialogin: Pakota sopimuksen allekirjoittaminen uudelleen" styles="margin-top: 15px; margin-bottom: 5px;" matIcon="sync"> Pakota sopimuksen allekirjoittaminen uudelleen </app-secondary-button>
              }
              @if (sopimuskausi.naytaPeruutaSopimuksenPaattyminen) {
                <app-primary-button (click)="peruutaSopimuksenPaattyminen(sopimuskausi.kausi.avain)" actionId="Avasi dialogin: Peruuta sopimuksen päättyminen" styles="margin-top: 15px; margin-bottom: 5px;" matIcon="cancel"> Peruuta sopimuksen päättyminen </app-primary-button>
              }
              @if (sopimuskausi.tauot.length > 0) {
                <div style="padding-top: 15px; padding-left: 10px">
                  <div style="font-weight: bold">sopimuskausi tauolla</div>
                  @for (taukorivi of sopimuskausi.tauot; track taukorivi) {
                    <div>
                      <table>
                        <tr>
                          <td>Aloituspvm:</td>
                          <td colspan="2">{{ taukorivi.tauko.alkaa | lokaalipvm | async }}</td>
                        </tr>
                        <tr>
                          <td>Lopetuspvm:</td>
                          <td colspan="2">{{ taukorivi.tauko.loppuu | lokaalipvm | async }}</td>
                        </tr>
                        @if (sopimuskausi.devaaja) {
                          <tr>
                            <td>Luotu:</td>
                            <td>{{ taukorivi.tauko.luotu | ltimestamptime | async }}</td>
                            <td>{{ taukorivi.luoja }}</td>
                          </tr>
                          <tr>
                            <td>Päivitetty:</td>
                            <td>{{ taukorivi.tauko.paivitetty | ltimestamptime | async }}</td>
                            <td>{{ taukorivi.paivittaja }}</td>
                          </tr>
                        }
                      </table>
                      @if (taukorivi.tauko.muistutuspvm && taukorivi.naytetaankoMuokkaaNappi) {
                        <div style="text-align: left; display: flex; margin-bottom: 15px; padding-left: 30px; max-width: 600px; font-style: italic; margin-top: 10px; margin-bottom: 20px" class="gray-text">
                          <div>
                            <mat-icon style="margin-left: 5px; margin-right: 5px; font-size: 20px">info_outline</mat-icon>
                          </div>
                          <div>Tauolla olosta muistutetaan seuraavaksi {{ taukorivi.tauko.muistutuspvm | lokaalipvm | async }}.</div>
                        </div>
                      }
                      @if (taukorivi.naytetaankoMuokkaaNappi) {
                        <span (click)="muokkaaTaukoa(sopimuskausi.kausi, taukorivi.tauko, false)" style="color: black; text-decoration: underline; cursor: pointer; display: inline-block; margin-top: 10px">Muokkaa tauon päivämääriä</span>
                      }
                    </div>
                  }
                </div>
              }
              @if (sopimuskausi.poytalaatikot.length > 0) {
                <div style="padding-top: 15px; padding-left: 10px">
                  <div style="font-weight: bold">Sopimus pöytälaatikossa</div>
                  @for (taukorivi of sopimuskausi.poytalaatikot; track taukorivi) {
                    <div>
                      <table>
                        <tr>
                          <td>Aloituspvm:</td>
                          <td colspan="2">{{ taukorivi.tauko.alkaa | lokaalipvm | async }}</td>
                        </tr>
                        <tr>
                          <td>Lopetuspvm:</td>
                          <td colspan="2">{{ taukorivi.tauko.loppuu | lokaalipvm | async }}</td>
                        </tr>
                        @if (sopimuskausi.devaaja) {
                          <tr>
                            <td>Luotu:</td>
                            <td>{{ taukorivi.tauko.luotu | ltimestamptime | async }}</td>
                            <td>{{ taukorivi.luoja }}</td>
                          </tr>
                          <tr>
                            <td>Päivitetty:</td>
                            <td>{{ taukorivi.tauko.paivitetty | ltimestamptime | async }}</td>
                            <td>{{ taukorivi.paivittaja }}</td>
                          </tr>
                        }
                      </table>
                      <!-- <div style="text-align: left; display: flex; margin-bottom: 15px; padding-left: 30px; max-width: 600px; font-style: italic; margin-top: 10px; margin-bottom: 20px;" class="gray-text">
                      <div>
                        <mat-icon style="margin-left: 5px; margin-right: 5px; font-size: 20px;">info_outline</mat-icon>
                      </div>
                      <div>
                        Asiakkaan käyttäjien aktiivisuus poistetaan {{ taukorivi.tauko.alkaa | lokaalipvm | async }} aamuyöllä.<br />
                        HUOM! Lemonator EI palauta käyttäjien aktiivisuutta. Palauta aktiivisuus manuaalisesti kun pöytälaatikkokausi päättyy.
                      </div>
                    </div> -->
                      @if (taukorivi.naytetaankoMuokkaaNappi) {
                        <span (click)="muokkaaTaukoa(sopimuskausi.kausi, taukorivi.tauko, false)" style="color: black; text-decoration: underline; cursor: pointer; display: inline-block; margin-top: 10px">Muokkaa pöytälaattikkojakson päivämääriä</span>
                      }
                    </div>
                  }
                </div>
              }
              @if (sopimuskausi.kausi.loppuu) {
                <div>
                  <hr style="margin-top: 35px; margin-bottom: 25px" />
                  <table>
                    <tr>
                      <th style="text-align: left">Lopetuspvm:</th>
                      <td>{{ sopimuskausi.kausi.loppuu | lokaalipvm | async }}</td>
                    </tr>
                    <tr>
                      <th style="text-align: left">{{ sopimuskausi.syyOtsikko }}:</th>
                      <td>{{ sopimuskausi.syy }}</td>
                    </tr>
                    <tr>
                      <th style="text-align: left">Lisätiedot:</th>
                      <td>{{ sopimuskausi.lisatiedot }}</td>
                    </tr>
                  </table>
                </div>
              }
              @if (!sopimuskausi.kausi.loppuu) {
                <div style="margin-top: 15px; margin-bottom: 10px; text-align: right">
                  @if (sopimuskausi.naytaLaitaTauolle) {
                    <app-secondary-button (click)="laitaPoytalaatikkoon(sopimuskausi.kausi)" actionId="Avasi dialogin: Laita sopimus pöytälaatikkoon" styles="margin-right: 15px;"> Laita pöytälaatikkoon </app-secondary-button>
                  }
                  @if (sopimuskausi.naytaLaitaTauolle) {
                    <app-secondary-button (click)="laitaTauolle(sopimuskausi.kausi)" actionId="Avasi dialogin: Laita sopimus tauolle" styles="margin-right: 15px;"> Laita tauolle </app-secondary-button>
                  }
                  <app-secondary-button (click)="paataSopimuskausi(sopimuskausi.kausi)" actionId="Avasi dialogin: Päätä sopimuskausi" styles="padding-left: 8px;" matIcon="block"> Päätä sopimuskausi </app-secondary-button>
                </div>
              }
              @if (sopimuskausi.isEditing) {
                <app-sopimusversio [lomake]="sopimusversioLomake"></app-sopimusversio>
              } @else {
                <div class="light-blue-text card-title">Palvelukokonaisuus</div>
                <div class="section">
                  <div class="section-title">Palvelupaketit</div>
                  <mat-radio-group [disabled]="true" [value]="sopimuskausi?.valittuVersio?.palvelupaketti || null">
                    @for (palvelupaketti of palvelupaketit; track palvelupaketti) {
                      <mat-radio-button [value]="palvelupaketti.value">{{ palvelupaketti.name }}</mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
                <div class="section">
                  <div class="section-title">Lisäpalvelut</div>
                  <div style="display: flex">
                    <!-- <div>
                  <div>Kirjanpidon lisäpalvelut:</div>
                  <mat-checkbox [disabled]="true" [checked]="!!sopimuskausi?.valittuVersio?.lisapalvelut?.ENNAKKOVEROJEN_SEURANTA">Ennakkoverojen seuranta</mat-checkbox>
                  <div style="margin-top: 10px;">Ostolaskut:</div>
                  <mat-checkbox [disabled]="true" [checked]="!!sopimuskausi?.valittuVersio?.lisapalvelut?.OSTOLASKUJEN_MAKSAMINEN">Ostolaskujen maksaminen</mat-checkbox>
                  <mat-checkbox [disabled]="true" [checked]="!!sopimuskausi?.valittuVersio?.lisapalvelut?.KIRJANPIDON_RESKONTRA">Reskontran hoito (kirjanpito)</mat-checkbox>
                </div> -->
                    <div>
                      <div>Palkanlaskenta:</div>
                      <mat-checkbox [disabled]="true" [checked]="!!sopimuskausi?.valittuVersio?.lisapalvelut?.PALKAT">Palkat palvelu</mat-checkbox>
                      <!-- <div style="margin-top: 10px;">Myyntilaskutus:</div>
                  <mat-checkbox [disabled]="true" [checked]="!!sopimuskausi?.valittuVersio?.lisapalvelut?.MYYNTILASKUJEN_LAHETTAMINEN">Myyntilaskujen lähettäminen</mat-checkbox>
                  <mat-checkbox [disabled]="true" [checked]="!!sopimuskausi?.valittuVersio?.lisapalvelut?.RESKONTRAN_HOITO">Reskontran hoito</mat-checkbox>
                  <mat-checkbox [disabled]="true" [checked]="!!sopimuskausi?.valittuVersio?.lisapalvelut?.SAATAVIEN_VALVONTA">Saatavien valvonta</mat-checkbox> -->
                    </div>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title">Voimassa alkaen</div>
                  <mat-form-field style="width: 200px">
                    <mat-label>Voimassa alkaen</mat-label>
                    <input [disabled]="true" [value]="sopimuskausi?.valittuVersio?.voimassaAlkaen | lnumberpvml: 'fi'" type="text" matInput data-lpignore="true" required />
                  </mat-form-field>
                </div>
              }
              @if (sopimuskausi.kausi.loppuu) {
                <div style="margin-top: 15px; margin-bottom: 10px">
                  <span (click)="paataSopimuskausi(sopimuskausi.kausi)" style="color: black; text-decoration: underline; cursor: pointer; display: inline-block; margin-top: 10px">Muokkaa sopimuksen päättymistä</span>
                </div>
              }
              <div>
                @if (sopimuskausi.hyvaksynnat.length > 0) {
                  <div style="display: flex; align-items: flex-end; flex-direction: column; opacity: 55%">
                    @for (hyvaksynta of sopimuskausi.hyvaksynnat; track hyvaksynta) {
                      <div>{{ sopimuskausi.onkoAiempiaVersioita ? 'Hyväksynyt' : 'Allekirjoittanut' }} {{ hyvaksynta.hyvaksynta.pvm | ltimestamptime | async }}: {{ hyvaksynta.hyvaksyja }}</div>
                    }
                  </div>
                }
              </div>
              @if (!sopimuskausi.isEditing) {
                <div class="bottom-action-bar">
                  <div>
                    <button [style.visibility]="sopimuskausi.onkoAiempiaVersioita ? 'visible' : 'hidden'" mat-button (click)="vaihdaSopimuskausiVersio(sopimuskausi, 'prev')"><i class="icon ion-md-arrow-dropleft nav-arrow-left" style="margin-right: 10px"></i>Aiempi versio</button>
                    <button [style.visibility]="sopimuskausi.onkoSeuraaviaVersiota ? 'visible' : 'hidden'" mat-button (click)="vaihdaSopimuskausiVersio(sopimuskausi, 'next')">Seuraava versio<i class="icon ion-md-arrow-dropright nav-arrow-right"></i></button>
                  </div>
                  @if (!sopimuskausi.onkoSeuraaviaVersiota && (!!sopimuskausi.kausi.sopimusversiot?.length || (kirjanpitajaOnLuottoObservable | async))) {
                    <button (click)="toggleIsEditing(true, sopimuskausi)" mat-button style="text-decoration: underline">Muokkaa palvelukokonaisuutta</button>
                  }
                </div>
              } @else {
                <div class="bottom-action-bar" style="justify-content: flex-end">
                  <div>
                    <app-secondary-button actionId="Peruuta" (click)="toggleIsEditing(false, sopimuskausi)" style="margin-right: 10px">Peruuta</app-secondary-button>
                    <app-primary-button actionId="Tallenna ja lähetä hyväksyttäväksi" (click)="tallennaMuutokset(sopimuskausi)">Tallenna ja lähetä hyväksyttäväksi</app-primary-button>
                  </div>
                </div>
              }
              <div class="bottom-action-bar" style="font-size: 11px; font-style: italic">
                {{ sopimuskausi.valittuVersio?.luotu ? 'Versio tallennettu ' + (sopimuskausi.valittuVersio?.luotu | ltimestamptime | async) : '' }}
              </div>
            </mat-card-content>
          </mat-card>
          @if (sopimuskausi.kausi.loppuu) {
            <div style="display: flex; align-items: flex-end">
              <div style="display: flex; margin-bottom: 15px; padding-left: 30px; max-width: 600px; font-style: italic" class="gray-text">
                <div>
                  <mat-icon style="margin-left: 5px; margin-right: 5px; font-size: 20px">info_outline</mat-icon>
                </div>
                <div>
                  @if (!sopimuskausi.onkoPurku) {
                    <div>
                      <p>Sopimuskausi päättyy {{ sopimuskausi.kausi.loppuu | lokaalipvm | async }}. Asiakkaan Lemonaid-tunnukset suljetaan {{ sopimuskausi.kausi.loppuu | lokaalipvm | async }} lukuun ottamatta aineiston toimitusta joka on auki {{ sopimuskausi.kausi.tositteidenToimitusLoppuu | lokaalipvm | async }} saakka (päivän loppuun asti).</p>
                      @if (sopimuskausi.kausi.lahetaPaattymassaEmail || sopimuskausi.kausi.lahetaPaattynytEmail) {
                        Asiakkaalle lähetetään {{ sopimuskausi.kausi.lahetaPaattymassaEmail && sopimuskausi.kausi.lahetaPaattynytEmail ? 'seuraavat sähköpostit' : 'seuraava sähköposti' }} automaattisesti:
                        @if (sopimuskausi.kausi.lahetaPaattymassaEmail) {
                          <div style="padding-left: 10px">- {{ sopimuskausi.sopimusPaattyyPianEmailDate | lokaalipvm | async }} Sopimuksesi päättyy pian</div>
                        }
                        @if (sopimuskausi.kausi.lahetaPaattynytEmail) {
                          <div style="padding-left: 10px">- {{ sopimuskausi.sopimusOnPaattynytEmailDate | lokaalipvm | async }} Sopimuksesi on päättynyt</div>
                        }
                      }
                    </div>
                  }
                  @if (sopimuskausi.onkoPurku) {
                    <div>
                      <p>*Sopimuskausi päättyy {{ sopimuskausi.kausi.loppuu | lokaalipvm | async }}. Asiakkaan Lemonaid-tunnukset suljetaan {{ sopimuskausi.kausi.loppuu | lokaalipvm | async }} myös aineiston toimittamisen osalta.</p>
                      Purkutilanteessa asiakkaalle ei lähetetä automaattisia sähköposteja.
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <div>Asiakkaalla ei ole yhtään sopimuskautta</div>
  }

  @if (sopimuskausiError()) {
    <mat-error style="margin: 10px">{{ sopimuskausiError() }}</mat-error>
  }
  @if (naytaLisaaObservable | async) {
    <div style="padding-top: 10px; margin-left: 40px; margin-top: 30px; padding-bottom: 1.25em">
      <app-secondary-button (click)="lisaaSopimuskausi()" actionId="Avasi dialogin: Lisää sopimuskausi" additionalClass="mat-elevation-z4" styles="padding-left: 6px" matIcon="add"> Lisää sopimuskausi </app-secondary-button>
    </div>
  }
</div>
